import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import * as styles from './CommentHistoryView.module.scss';
import PageLayout from '../../app/layout/PageLayout';
import { useRightPanel } from '../../app/layout/RightPanel';
import { AssetTokenProvider } from '../../editor/AssetTokenContext';
import QuillContext from '../../editor/QuillContext';
import { gql } from '../../graphql/generated/gql';
import PageMeta from '../../utils/PageMeta';
import useSlug from '../../utils/router/useSlug';
import HistoricalPost from '../history/HistoricalPost';
import HistorySidebar from '../history/HistorySidebar';

const POST_QUERY = gql(/** @complexity 3 */ `
  query CommentHistoryViewPostQuery($id: ID!) {
    post(id: $id) {
      id
      title
      content(isLatest: true) {
        id
        delta
      }
    }
    entityAssetToken(entityId: $id, entityType: POST) {
      ...AssetTokenProvider_entityAssetToken
    }
  }
`);

const CommentHistoryView = () => {
  const [postId] = useSlug('postSlug');

  const { data: { post, entityAssetToken } = {} } = useQuery(POST_QUERY, {
    variables: { id: postId },
  });

  const { openRightPanel } = useRightPanel();

  useEffect(() => {
    openRightPanel(<HistorySidebar postId={postId} tab="comments" />);
  }, [postId, openRightPanel]);

  const defaultTitle = 'Comment History - Slab';
  const postTitle = post?.title;
  const documentTitle = postTitle
    ? `${postTitle} - ${defaultTitle}`
    : defaultTitle;

  return (
    <PageLayout.Content className={styles.content} noPaddingX noPaddingY>
      <PageMeta title={documentTitle} />
      {post && (
        <QuillContext>
          <div className={styles.editorWrapper}>
            <div className={styles.editor}>
              <AssetTokenProvider entityAssetToken={entityAssetToken}>
                <HistoricalPost content={post.content.delta} />
              </AssetTokenProvider>
            </div>
          </div>
        </QuillContext>
      )}
    </PageLayout.Content>
  );
};

export default CommentHistoryView;
